import {
    HiveBodyBeeImage,
    HiveBodyBeeWrapper,
    HiveBodyMarkImage, HiveBodyMarkValue,
    HiveBodyUterusSubtitle,
    HiveBodyUterusTitle,
    HiveBodyUterusValue,
    HiveBodyUterusWrapper
} from "features/hive/ui/HiveBody/styles.ts";
import { EditIcon } from "shared/ui/icons/editIcon.tsx";
import { useCurrentHiveStore } from "entities/currentHive";
import {HiveEdit} from "features/hive/ui/HiveEdit/HiveEdit.tsx";
import {useState} from "react";

import beeImg from "shared/assets/img/bee.png";

import mark0 from "/src/shared/assets/img/marks/0.png";
import mark1 from "/src/shared/assets/img/marks/1.png";
import mark2 from "/src/shared/assets/img/marks/2.png";
import mark3 from "/src/shared/assets/img/marks/3.png";
import mark4 from "/src/shared/assets/img/marks/4.png";

export const HiveBodyUterus = () => {
    const currentHive = useCurrentHiveStore((s) => s.currentHive);

    const uterusColor = currentHive?.uterus.color ?? "";
    // const markSrc = uterusColor ? `/src/shared/assets/img/marks/${uterusColor}.png` : null;

    let markSrc = "";

    switch (uterusColor) {
        case "0":
            markSrc = mark0
            break;
        case "1":
            markSrc = mark1
            break;
        case "2":
            markSrc = mark2
            break;
        case "3":
            markSrc = mark3
            break;
        case "4":
            markSrc = mark4
            break;
    }

    const [isOpenHiveEdit, setIsOpenHiveEdit] = useState<boolean>(false);

    return (
        <>
            <HiveBodyUterusWrapper>
                <HiveBodyUterusTitle onClick={() => setIsOpenHiveEdit(true)}>
                    <h3>Данные матки</h3>
                    <EditIcon />
                </HiveBodyUterusTitle>
                <HiveBodyUterusSubtitle>Год</HiveBodyUterusSubtitle>
                <HiveBodyUterusValue>{currentHive?.uterus.year || '—'}</HiveBodyUterusValue>
                <HiveBodyUterusSubtitle>Номер метки</HiveBodyUterusSubtitle>
                <HiveBodyUterusValue>{currentHive?.uterus.mark || '—'}</HiveBodyUterusValue>
                <HiveBodyUterusSubtitle>Порода</HiveBodyUterusSubtitle>
                <HiveBodyUterusValue>{currentHive?.uterus.breed || '—'}</HiveBodyUterusValue>
                <HiveBodyBeeWrapper>
                    <HiveBodyBeeImage src={beeImg} />
                    {markSrc && <HiveBodyMarkImage src={markSrc} />}
                    <HiveBodyMarkValue>
                        {currentHive?.uterus.mark}
                    </HiveBodyMarkValue>
                </HiveBodyBeeWrapper>
            </HiveBodyUterusWrapper>
            <HiveEdit isOpen={isOpenHiveEdit} onClose={() => setIsOpenHiveEdit(false)}/>
        </>
    );
};
